import { handleActions } from 'redux-actions';
import SettlementsType from '../types/SettlementsType';

const initialState = {
  settlementDetails: {},
};

export const SettlementDetails = handleActions(
  {
    [SettlementsType.actions.fetchSettlementDetailsSuccess]: (currentState, { payload: { settlement: settlementDetails } }) => {
      return {
        settlementDetails,
      };
    },
  },
  initialState
);

export const getSettlementDetails = (state) => {
  const { SettlementDetails } = state;
  return SettlementDetails.settlementDetails;
};
